var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.handle}},[(_vm.cartLoaded)?_c('inner-cart',{ref:"inner"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }